import P from '../Assets/Images/Execs/President.png'
import VP from '../Assets/Images/Execs/VP.png'
import t from '../Assets/Images/Execs/treasury.png'
import ChromaGrid from './Components/ChromaGrid'

export default function Team() {
    const execs = [
        //          {
        { title: 'Aksorn D\'souza', subtitle: 'President', handle: "@perhaps_kenneth", borderColor: "#3B82F6", url: 'https://www.linkedin.com/in/kenneth-moen-arnold2005', image: P },
        { title: 'Raphael Gomes', subtitle: 'Vice President', handle: '@miku_amele', url: 'https://www.linkedin.com/in/mikiyas-haile', borderColor: "#3B82F6", image: VP },
        { title: 'Rayan Ali', subtitle: 'VP Treasurer', handle: '@kelvin._.xd', url: 'https://www.linkedin.com/in/kelvin-du-318130297', borderColor: "#3B82F6", image: t },

    ]
    return (
        <div style={{ minHeight: '100vh', position: 'relative', padding: '20px', backgroundColor: 'black' }}>
            <br/> <br/>
            <p style={{ textAlign: 'center' }} className='highlight'> META's Executive Team</p>
            <br/> <br/>
            <ChromaGrid
                items={execs}
                radius={300}
                damping={0.45}
                fadeOut={0.6}
                ease="power3.out"
            />
        </div>
    )
}
